"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMatchingQueries = exports.parseQuery = void 0;
var lodash_1 = require("lodash");
exports.parseQuery = function (query) {
    // Only works for `and` queries for now.
    var parts = query
        .split('and')
        .map(function (part) { return part.trim(); })
        // Remove parentheses
        .map(function (part) { return part.replace(/[()]/g, ''); });
    return parts.reduce(function (accum, part) {
        var _a = __read(part.split(':'), 2), _b = _a[0], key = _b === void 0 ? '' : _b, _c = _a[1], val = _c === void 0 ? '' : _c;
        accum[key.trim()] = parseInt(val, 10);
        return accum;
    }, {});
};
var doesQueryMatch = function (queryables, query) {
    return [
        queryables.width >= (query['min-width'] || 0),
        queryables.width <= (query['max-width'] || Infinity),
    ].every(Boolean);
};
exports.findMatchingQueries = function (queryables, queries) {
    return lodash_1.reduce(queries, function (accum, queryToCheck) {
        var mediaQuery = queryToCheck;
        var parsedQuery = exports.parseQuery(mediaQuery);
        accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
        return accum;
    }, {});
};
exports.default = exports.findMatchingQueries;
